import SPELLS from 'common/SPELLS';
import CLASSIC_SPELLS from 'common/SPELLS/classic';
import { TALENTS_PALADIN } from 'common/TALENTS';

const spells: number[] = [
  /**
   * This can consist of boss mechanics marked as casts, buff applications marked
   * as separate casts from the normal ability, toy casts that some people macro
   * into their abilities and so forth
   */
  SPELLS.MELEE.id, // Auto attack
  SPELLS.AUTO_SHOT.id, // hunter auto attack (classic)
  SPELLS.CHI_BURST_HEAL.id, // this is the "tick" when you hit a player, the actual cast has a different id
  SPELLS.SHADOWY_APPARITION.id,
  SPELLS.SHADOWY_APPARITION_CAST.id, // Shadow priest shadow apparitions passive
  SPELLS.PRIMAL_FURY.id, // Feral Druid "extra CP on crit" proc causes a cast event
  SPELLS.BLOW_DARKMOON_WHISTLE.id, //Darkmoon Whistle active that some people macro into abilities
  SPELLS.DARKMOON_FIREWORK.id, //Darkmoon Firework toy
  SPELLS.BIG_RED_RAYS.id, //Big Red Raygun active effect
  SPELLS.MUTILATE_OFFHAND.id, // Mutilate off hand
  SPELLS.DIVINE_HYMN_HEAL.id, //The heal component of divine hymn
  SPELLS.CHARGE_2.id, // The damage component of charge
  SPELLS.BLOOD_ELF_ILLUSION.id, // Orb of the Sin'dorei
  SPELLS.CHI_SURGE_DEBUFF.id,

  //region Boss abilities
  SPELLS.ULGRAX_GRAB_VISCERA.id,
  SPELLS.ULGRAX_FEED.id,
  //endregion

  //region Items
  SPELLS.PHASE_BLINK.id, // 11.2 Legendary cloak
  //endregion

  //region Zone Procs
  SPELLS.VOIDLUST.id,
  //endregion

  //region Consumables
  //endregion

  //region Enchants
  //endregion

  //region Death Knight
  SPELLS.BREATH_OF_SINDRAGOSA_TALENT_DAMAGE_TICK.id,
  SPELLS.RUNE_1.id,
  SPELLS.RUNE_2.id,
  SPELLS.RUNE_3.id,
  SPELLS.COMMANDER_OF_THE_DEAD_BUFF.id,
  SPELLS.EXTERMINATE_FIRST_HIT.id,
  SPELLS.EXTERMINATE_SECOND_HIT.id,
  SPELLS.INFLICTION_OF_SORROW.id,
  SPELLS.DISEASE_CLOUD.id,

  //endregion

  //region Evoker
  SPELLS.VERDANT_EMBRACE_HEAL.id,
  SPELLS.TWIN_FLAME.id,
  SPELLS.CHARGED_BLAST.id,
  //endregion

  //region Hunter
  SPELLS.BARBED_SHOT_PET_BUFF.id, //The buff applied to BM Hunter pet when casting Barbed Shot
  SPELLS.DIRE_BEAST_SUMMON.id, //Additional cast event associated with summoning a Dire Beast
  SPELLS.DIRE_BEAST_GLYPHED.id, //Additional cast event associated with summoning a Dire Beast with Glyph of Dire Stable
  SPELLS.DIRE_BEAST_SUMMON.id, // Turned into a passive proc
  SPELLS.URSINE_FURY_BEASTS.id, // Pack Leader - Ursine Fury Spawns 2 beasts. Spams out console about duplicate IDs
  //endregion

  //region Mage
  SPELLS.GREATER_INVISIBILITY_BUFF.id,
  //endregion

  //region Demon Hunter
  SPELLS.FRACTURE_MAIN_HAND.id, // Fracture main hand damage ability
  SPELLS.FRACTURE_OFF_HAND.id, // Fracture off hand damage ability
  SPELLS.SOUL_FRAGMENT.id, // Soul Fragments generated by abilities
  SPELLS.SOUL_FRAGMENT_2.id, // new soul fragment id in Midnight - devourer only?
  SPELLS.SOUL_FRAGMENT_KILLING_BLOW.id, // Soul Fragment that are sometimes generated by killing blows (it does not affect much of a rotation, because it's usually ~1:200, comparing to usual soul fragment generation)
  SPELLS.SOUL_FRAGMENT_KILLING_BLOW_2.id, // Soul Fragment that are sometimes generated by killing blows (it does not affect much of a rotation, because it's usually ~1:200, comparing to usual soul fragment generation)
  SPELLS.FELBLADE_DAMAGE.id, // The spell that generates fury when casting
  SPELLS.FELBLADE_CHARGE.id, // The spell that charges the player to the target
  SPELLS.THE_HUNT_CHARGE.id, // The impact from The Hunt
  SPELLS.SOUL_CARVER_OFF_HAND.id, // Soul Carver off hand damage ability
  SPELLS.THROW_GLAIVE_VENGEANCE_DAMAGE.id, // Vengeance Throw Glaive damage ability
  SPELLS.COLLECTIVE_ANGUISH_EYE_BEAM.id, // Vengeance Collective Anguish Eye Beam
  SPELLS.THROW_GLAIVE_PROC_BLADE_DANCE.id, // extra throw from Amirdrassil 2pc
  SPELLS.THROW_GLAIVE_PROC_FURIOUS_THROWS.id, // extra throw from Furious Throws talent
  SPELLS.FAKE_VOIDBLADE_CAST.id, // Thrown just before the actual cast, duplicate
  SPELLS.FAKE_THEHUNT_CAST.id, // Duplicate of the actual cast, thrown right after
  //endregion

  //region druid
  SPELLS.TRANQUILITY_HEAL.id,
  //endregion

  //region monk
  SPELLS.ESCAPE_FROM_REALITY_CAST.id,
  SPELLS.GIFT_OF_THE_OX_1.id,
  SPELLS.GIFT_OF_THE_OX_2.id,
  SPELLS.GIFT_OF_THE_OX_3.id,
  SPELLS.GIFT_OF_THE_OX_4.id,
  SPELLS.GIFT_OF_THE_OX_5.id,
  SPELLS.GIFT_OF_THE_OX_6.id,
  SPELLS.GIFT_OF_THE_OX_7.id,
  SPELLS.GIFT_OF_THE_OX_8.id,
  //endregion

  //region paladin
  SPELLS.RECLAMATION_CAST.id,
  SPELLS.SACROSANCT_CRUSADE_BUFF.id,
  SPELLS.EMPYREAN_HAMMER.id,
  TALENTS_PALADIN.DIVINE_HAMMER_TALENT.id,
  SPELLS.DIVINE_HAMMER_EXTEND.id,
  SPELLS.DIVINE_HAMMER_FAKE_CAST.id,
  SPELLS.CRUSADING_STRIKES.id,
  //endregion

  //region shaman
  SPELLS.CLOUDBURST_TOTEM_RECALL.id, // Cloudburst reactivation
  SPELLS.FERAL_LUNGE_NOT_A_CAST.id, // duplicate event of regular Feral Lunge cast
  SPELLS.HEALING_RAIN_TOTEMIC.id,
  SPELLS.DOOM_WINDS_TICK.id,
  SPELLS.FLAME_SHOCK_DUPLICATE.id,
  //endregion

  //region warlock
  //endregion

  //region warrior
  SPELLS.RAMPAGE_1.id,
  SPELLS.RAMPAGE_2.id,
  SPELLS.RAMPAGE_3.id,
  SPELLS.RAMPAGE_4.id,
  SPELLS.ODYNS_FURY_1.id,
  SPELLS.ODYNS_FURY_2.id,
  SPELLS.ODYNS_FURY_3.id,
  SPELLS.HACK_AND_SLASH.id,
  SPELLS.WRATH_AND_FURY.id,
  //endregion

  //region Rogue
  SPELLS.DISPATCH_COUP_DE_GRACE.id,
  //endregion

  //region classic druid
  CLASSIC_SPELLS.ECLIPSE_LUNAR.id,
  CLASSIC_SPELLS.ECLIPSE_SOLAR.id,
  CLASSIC_SPELLS.TRANQUILITY_HEAL.id,
  //endregion

  //region classic hunter
  CLASSIC_SPELLS.LOCK_AND_LOAD.id,
  //endregion

  //region classic priest
  CLASSIC_SPELLS.MIND_SEAR_TICK.id,
  //endregion

  //region classic warlock
  CLASSIC_SPELLS.CORRUPTION_TICK.id,
  CLASSIC_SPELLS.RAIN_OF_FIRE_DAMAGE.id,
  CLASSIC_SPELLS.SHADOW_TRANCE.id,
  //endregion

  //region classic warrior
  CLASSIC_SPELLS.BLADESTORM_TRIGGERED_SPELL.id,
  //endregion

  //region classic monk
  CLASSIC_SPELLS.GIFT_OF_THE_OX_SPAWN_1.id,
  CLASSIC_SPELLS.GIFT_OF_THE_OX_SPAWN_2.id,
  CLASSIC_SPELLS.FISTS_OF_FURY_TICK.id,
  CLASSIC_SPELLS.SPEAR_HAND_STRIKE_SILENCE.id,
  //endregion

  //region trinket
  SPELLS.EYE_OF_THE_DROWNING_VOID.id,
  //endregion
  //region Embellishments
  //endregion
];

export default spells;
